import React from 'react';
import { graphql } from 'gatsby';
import CustomSoftwareDevelopmentPage from '../../components/CustomSoftwareDevelopmentPage';
import Footer from '../../components/Footer';
import { PageWrapper } from '../../components/homePage/styled';
import Header from '../../components/Header';
import SEO from '../../components/SEO';

const CustomSoftwareDevelopment = ({
  data: {
    site: {
      siteMetadata: { titleTemplate, siteUrl },
    },
    pageInfo: {
      frontmatter: { seoTitle, description, keywords },
    },
  },
}) => {
  return (
    <PageWrapper>
      <SEO
        titleTemplate={titleTemplate}
        title={seoTitle}
        keywords={keywords}
        url={siteUrl}
        description={description}
      />
      <Header />
      <CustomSoftwareDevelopmentPage />
      <Footer />
    </PageWrapper>
  );
};

export const query = graphql`
  {
    site {
      siteMetadata {
        titleTemplate
        siteUrl
      }
    }
    pageInfo: markdownRemark(
      frontmatter: { name: { eq: "services/custom-software-development" } }
    ) {
      frontmatter {
        title
        longTitle
        seoTitle
        description
        keywords
      }
    }
  }
`;

export default CustomSoftwareDevelopment;
